var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.073,
    height: 70.197,
    viewBox: "0 0 70.073 70.197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon feather-phone-call",
    d: "M43.31 13.91a15.513 15.513 0 0 1 12.255 12.256M43.31 1.5a27.923 27.923 0 0 1 24.665 24.635m-3.1 24.759V60.2a6.205 6.205 0 0 1-6.764 6.205 61.4 61.4 0 0 1-26.775-9.525 60.5 60.5 0 0 1-18.618-18.614 61.4 61.4 0 0 1-9.525-26.9A6.205 6.205 0 0 1 9.367 4.6h9.308a6.205 6.205 0 0 1 6.205 5.339 39.837 39.837 0 0 0 2.172 8.718 6.205 6.205 0 0 1-1.4 6.546l-3.94 3.94A49.642 49.642 0 0 0 40.331 47.76l3.94-3.94a6.205 6.205 0 0 1 6.546-1.4 39.837 39.837 0 0 0 8.718 2.172 6.205 6.205 0 0 1 5.338 6.301z",
    transform: "translate(-.665 1.261)",
    style: {
      fill: "none",
      stroke: "#535252",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 5
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.1e8c14e4a0c32780c61b4a54a5b838e7.svg";
export { ForwardRef as ReactComponent };